import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { FamilyFestFaqTypeEnum } from '@application/enums/family-fest-faq-type-enum';
import { CheckOutlined } from '@mui/icons-material';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import { SingleSelect } from '@ui/components/common/Autocomplete';
import BDrawer from '@ui/components/common/BDrawer';
import CustomDialog from '@ui/components/common/Dialog';
import { ControlledFilledTextField } from '@ui/components/common/TextField';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useFaqTypeOptions } from './FaqTypeFilter';
const NewCategoryDialog = ({ open, onClose, onCreate, isFamilyEvent = false, defaultFaqType = FamilyFestFaqTypeEnum.Registration }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const faqTypeOptions = useFaqTypeOptions();
    const { control, handleSubmit, reset, watch, formState: { isSubmitting } } = useForm({
        defaultValues: {
            categoryName: '',
            faqType: defaultFaqType
        }
    });
    const categoryName = watch('categoryName');
    React.useEffect(() => {
        if (open) {
            reset({ categoryName: '', faqType: defaultFaqType });
        }
    }, [open, reset, defaultFaqType]);
    const handleCancel = () => {
        reset({ categoryName: '', faqType: defaultFaqType });
        onClose();
    };
    const handleCreate = handleSubmit((data) => {
        onCreate?.({ name: data.categoryName.trim(), familyFestFaqType: data.faqType ?? defaultFaqType });
        onClose();
    });
    const formContent = (_jsxs(Box, { p: 2, display: 'flex', flexDirection: 'column', gap: 2, children: [isFamilyEvent && (_jsx(SingleSelect, { bg: 'grey8', control: control, name: 'faqType', label: t('events.eventDetails.faqTab.faqType.categoryLabel'), options: faqTypeOptions, disableClearable: true })), _jsx(ControlledFilledTextField, { bg: 'grey8', control: control, label: t('events.eventDetails.faqTab.newCategoryDialog.categoryName'), name: 'categoryName' })] }));
    const dialogActions = (_jsxs(_Fragment, { children: [_jsx(Button, { fullWidth: true, variant: 'outlined', color: 'inherit', size: 'large', onClick: handleCancel, disabled: isSubmitting, children: t('actions.cancel') }), _jsx(Button, { fullWidth: true, variant: 'contained', color: 'inherit', size: 'large', startIcon: _jsx(CheckOutlined, {}), onClick: handleCreate, disabled: !categoryName?.trim() || isSubmitting, children: t('actions.createNow') })] }));
    if (isSmallScreen) {
        return (_jsx(BDrawer, { anchor: 'bottom', open: open, onClose: handleCancel, title: t('events.eventDetails.faqTab.newCategoryDialog.title'), showBottomBar: true, dialogActions: dialogActions, children: formContent }));
    }
    return (_jsx(CustomDialog, { open: open, onClose: handleCancel, titleWithIcon: t('events.eventDetails.faqTab.newCategoryDialog.title'), titleIcon: '/assets/images/question-mark.png', actions: dialogActions, maxWidth: 'sm', backgroundVariant: 'white', closeIcon: true, children: _jsx(Box, { p: 1.5, sx: {
                maxHeight: '65vh',
                overflowY: 'auto'
            }, children: formContent }) }));
};
export default NewCategoryDialog;
